import axios from 'axios'
import Constants from "../constants";

export default {
  methods: {
    checkPermission(permId, entityType, entityId) {
      entityType = entityType || null;
      entityId = entityId || 0;
      return axios.get(`/api/admin/users/checkpermission?permissionId=${permId}&entityType=${entityType}&entityId=${entityId}`);
    },
    checkPermissions(permIds, entityType, entityId) {
      if (this.$route.params.action === "edit") {
        this.checkPermission(permIds[0], entityType, entityId)
          .then((response) => {
            if (!response.data) {
              Constants.alert.fire('Нет доступа', 'У Вас нет доступа к редактированию объекта этого класса.', 'error');
              this.isReadonly = true;
            }
        });
      } else if (this.$route.params.action === "view") {
        this.checkPermission(permIds[1], entityType, entityId)
          .then((response) => {
            if (!response.data) {
              Constants.alert.fire('Нет доступа', 'У Вас нет доступа к просмотру объекта этого класса.', 'error');
              this.$router.push('/');
            }
        });
      }
    },
    getAccessMatrix(permIds) {
      return axios.get(`/api/admin/permissions/accessmatrix?permissionIds=${permIds.join(',')}`);
    }
  }
}